<script lang="ts">
	import type { Device } from 'src/types/Device';

	import InputsReaderBasicView from 'src/components/Sidepanel/DeviceViews/InputsReader/InputsReaderBasicView.svelte';

	export let device: Device;
</script>

<InputsReaderBasicView {device} />
